/**
 * Make jQuery globally available
 * Must be imported first so legacy plugins (Bootstrap 3, etc.)
 * can find jQuery under window.$ and window.jQuery.
 */
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
export default jQuery;